import React from "react";
import Marquee from "react-fast-marquee";
import img1 from "../../assets/logos/1.png";
import img2 from "../../assets/logos/2.png";
import img3 from "../../assets/logos/3.png";
import img4 from "../../assets/logos/4.png";
import img5 from "../../assets/logos/5.png";
import img6 from "../../assets/logos/6.png";
import img7 from "../../assets/logos/7.png";
import img8 from "../../assets/logos/8.png";

const logos = [
  { img: img1, alt: "Logo 1", link: "https://example.com/1" },
  { img: img2, alt: "Logo 2", link: "https://example.com/2" },
  { img: img3, alt: "Logo 3", link: "https://example.com/3" },
  { img: img4, alt: "Logo 4", link: "https://example.com/4" },
  { img: img5, alt: "Logo 5", link: "https://example.com/5" },
  { img: img6, alt: "Logo 6", link: "https://example.com/6" },
  { img: img7, alt: "Logo 7", link: "https://example.com/7" },
  { img: img8, alt: "Logo 8", link: "https://example.com/8" },
];

export default function LogoCloud() {
  return (
    <div className="bg-white  overflow-hidden">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-700 text-center mb-8">
          Trusted by:
        </h2>
        <Marquee gradient={false} speed={40}>
          {logos.map((logo, index) => (
            <img 
              key={index}
              src={logo.img} 
              alt={logo.alt} 
              className="h-32 w-auto grayscale opacity-70 hover:opacity-100 transition-opacity duration-300 mx-4"
            />
          ))}
        </Marquee>
      </div>
    </div>
  );
}
